import { defineComponent as _defineComponent } from 'vue'
import IconSearch from "@/components/icons/IconSearch.vue";
import { ref } from "vue";

interface FormValues {
  search: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpForm',
  setup(__props) {

const openVariants = ref();
const searchVariant = ref([] as Array<string>);
const active = ref();
const formValues = ref({
  search: null,
} as FormValues);

function handleSubmit(val: FormValues) {
  console.log(val);
}
function setSearchValue(val: string) {
  formValues.value.search = val;
  openVariants.value = false;
  handleSubmit({ search: val });
}

function inputChange() {
  if (formValues.value.search) {
    searchVariant.value = ["123", "345", "567"];
    openVariants.value = true;
  } else {
    searchVariant.value = [];
    openVariants.value = false;
  }
}

return { __sfc: true,openVariants, searchVariant, active, formValues, handleSubmit, setSearchValue, inputChange, IconSearch }
}

})